import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import {
  Typography,
  Avatar,
  Collapse,
  TextField,
  Button,
} from "@material-ui/core";
import PropTypes from "prop-types";
import Star from "@material-ui/icons/StarBorderRounded";
import StarFilled from "@material-ui/icons/StarRounded";
import LogoIcon from "../../UIcomponent/Icon/Logo";
import Rating from "@material-ui/lab/Rating";
import MaterialThemeProvider from "../Material/MaterialThemeProvider";
import SwipeableViews from "react-swipeable-views";
import ThanksIcon from "@material-ui/icons/CheckOutlined";
import SentimentVeryDissatisfiedIcon from "@material-ui/icons/SentimentVeryDissatisfied";
import SentimentDissatisfiedIcon from "@material-ui/icons/SentimentDissatisfied";
import SentimentSatisfiedIcon from "@material-ui/icons/SentimentSatisfied";
import SentimentSatisfiedAltIcon from "@material-ui/icons/SentimentSatisfiedAltOutlined";
import SentimentVerySatisfiedIcon from "@material-ui/icons/SentimentVerySatisfied";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import Urls from "../../Utility/Urls";
import actions from "../../redux/actions";

const customIcons = {
  1: {
    icon: <SentimentVeryDissatisfiedIcon />,
    label: "Very Dissatisfied",
  },
  2: {
    icon: <SentimentDissatisfiedIcon />,
    label: "Dissatisfied",
  },
  3: {
    icon: <SentimentSatisfiedIcon />,
    label: "Neutral",
  },
  4: {
    icon: <SentimentSatisfiedAltIcon />,
    label: "Satisfied",
  },
  5: {
    icon: <SentimentVerySatisfiedIcon />,
    label: "Very Satisfied",
  },
};

const labels = ["خیلی بد", "بد", "متوسط", "خوب", "خیلی خوب"];

const StyledRating = withStyles((theme) => ({
  iconFilled: {
    color: theme.palette.primary.main,
  },
  iconHover: {
    color: theme.palette.primary.dark,
  },
}))(Rating);

function IconContainer(props) {
  const { value, ...other } = props;
  return <span {...other}>{customIcons[value].icon}</span>;
}

IconContainer.propTypes = {
  value: PropTypes.number.isRequired,
};
const useStyles = makeStyles((theme) => ({
  reviewCard: {
    width: "100%",
    borderRadius: 16,
    textAlign: "center",
  },
  reviewAvatar: {
    width: 70,
    height: 70,
    margin: "25px auto 8px auto",
  },

  lingoReviewAvatar: {
    backgroundColor: theme.palette.primary.main,
    width: 70,
    height: 70,
    margin: "25px auto 8px auto",
  },

  thanksReviewAvatar: {
    backgroundColor: theme.palette.secondary.main,
    width: 70,
    height: 70,
    margin: "25px auto 8px auto",
  },
  reviewContentTitle: {
    fontWeight: "bold",
    margin: "16px 0px",
    color: "#444",
    fontSize: 21,
  },
  rateContainer: {
    display: "flex",
    marginTop: 16,
    justifyContent: "center",
    width: "100%",
    "& svg": {
      margin: "0px 4px",
    },
  },
  rateLabel: {
    marginTop: 16,
    background: "transparent",
    color: theme.palette.primary.main,
    fontWeight: "bold",
  },
  rateContent: {
    margin: "16px 0px",
    textAlign: "left",
    direction: "ltr",
    paddingTop: 18,
  },
  rateWrapper: {
    width: "100%",
    maxWidth: "100%",
    overflowX: "hidden",
  },
  innerTextField: {
    paddingTop: 18,
  },
  name: {
    fontSize: "1.15rem",
  },
}));

function ReviewComponent(props) {
  const { mode, data, setData, setReview, isFetching } = props;
  const styles = useStyles();
  const [rate, setRate] = React.useState(0);
  const [lingoRate, setLingoRate] = React.useState(0);
  const teacherReviewRef = React.useRef();
  const technicalReviewRef = React.useRef();
  const theme = useTheme();

  let label = "";

  if (rate > 0) {
    label = labels[rate - 1];
  }

  let lingoLabel = "";
  if (rate > 0) {
    lingoLabel = labels[lingoRate - 1];
  }

  function submitUserReview() {
    let params = {
      Rate: rate,
      Comment: teacherReviewRef.current.value,
    };
    setReview(params);
  }

  function submitLingoReview() {
    let params = {
      Rate: lingoRate,
      ServiceName: "skyroom",
      Comment: technicalReviewRef.current.value,
    };
    setReview(params);
  }

  return (
    <SwipeableViews
      axis={theme.direction === "rtl" ? "x-reverse" : "x"}
      index={mode}
      onChangeIndex={(e) => {
        setData({ mode: e });
      }}
    >
      <div>
        <Typography className={styles.reviewContentTitle} variant="h5">
          به کلاس خود امتیاز دهید
        </Typography>
        <Avatar
          className={styles.reviewAvatar}
          src={Urls.avatar() + data.UserAvatar}
        />
        <Typography className={styles.name} variant="h6">
          {data.FirstName + " " + data.LastName}
        </Typography>
        <MaterialThemeProvider forceLtr>
          <div dir="ltr" className={styles.rateContainer}>
            <Rating
              emptyIcon={<Star />}
              icon={<StarFilled />}
              name="simple-controlled"
              value={rate}
              size="large"
              onChange={(event, newValue) => {
                setRate(newValue);
              }}
            />
          </div>
        </MaterialThemeProvider>
        <br />
        <Collapse in={rate > 0 && mode === 0}>
          <div className={styles.rateWrapper}>
            <Typography variant="button" color="primary">
              {label}
            </Typography>
            <TextField
              disabled={isFetching}
              variant="filled"
              multiline
              inputRef={teacherReviewRef}
              rows={4}
              placeholder="نظر خود را بنویسید..."
              InputProps={{
                disableUnderline: true,
                classes: {
                  root: styles.innerTextField,
                },
              }}
              className={styles.rateContent}
              fullWidth
            />
            <Button
              onClick={() => submitUserReview(data.Session.ID)}
              variant="contained"
              color="primary"
              fullWidth
            >
              ادامه
            </Button>
          </div>
        </Collapse>
      </div>
      <div>
        <Typography className={styles.reviewContentTitle} variant="h5">
          چقدر از کیفیت لینگوتاک راضی هستید؟
        </Typography>
        <Avatar className={styles.lingoReviewAvatar}>
          <LogoIcon />
        </Avatar>
        <MaterialThemeProvider forceLtr>
          <div dir="ltr" className={styles.rateContainer}>
            <StyledRating
              value={lingoRate}
              size="large"
              getLabelText={(value) => customIcons[value].label}
              IconContainerComponent={IconContainer}
              onChange={(event, newValue) => {
                setLingoRate(newValue);
              }}
            />
          </div>
        </MaterialThemeProvider>
        <br />
        <Collapse in={lingoRate > 0 && mode === 1}>
          <div className={styles.rateWrapper}>
            <Typography variant="button" color="primary">
              {lingoLabel}
            </Typography>
            <TextField
              disabled={isFetching}
              variant="filled"
              multiline
              inputRef={technicalReviewRef}
              rows={4}
              placeholder="نظر خود را بنویسید..."
              InputProps={{
                disableUnderline: true,
                classes: {
                  root: styles.innerTextField,
                },
              }}
              className={styles.rateContent}
              fullWidth
            />
            <Button
              onClick={() => submitLingoReview(data.Session.ID)}
              variant="contained"
              color="primary"
              fullWidth
            >
              ثبت نظرسنجی
            </Button>
          </div>
        </Collapse>
      </div>
      <div>
        <Typography className={styles.reviewContentTitle} variant="h5">
          نظر شما ثبت شد
        </Typography>
        <Avatar className={styles.thanksReviewAvatar}>
          <ThanksIcon />
        </Avatar>

        <Typography className={styles.reviewContentTitle} variant="h6">
          با تشکر
        </Typography>
      </div>
    </SwipeableViews>
  );
}

const mapStateToProps = (state) => ({
  data: state.dashboard.reviewModal.data.session,
  mode: state.dashboard.reviewModal.data.mode,
  isFetching: state.dashboard.review.fetching,
});

const mapDispatchToProps = (dispatch) => ({
  setReview: (params) => dispatch(actions.dashboard.review.setReview(params)),
  setData: (data) => dispatch(actions.dashboard.reviewModal.setData(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReviewComponent);
